export default __webpack_public_path__ + "9d576a833991ec27bbc4f43910afa7f7.svg";